import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import { initMonitoring, captureError } from './services/monitoring';
import './styles/global.css';
import './styles/journeys.css';

initMonitoring();

sessionStorage.removeItem('lazy_reload');

window.onerror = (msg, src, line, col, err) => {
  captureError(err || new Error(String(msg)), { source: src, line, col });
};
window.addEventListener('unhandledrejection', (e) => {
  captureError(e.reason instanceof Error ? e.reason : new Error(String(e.reason)), { type: 'unhandledrejection' });
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <FavoritesProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </FavoritesProvider>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
